import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportingService } from '../reporting.service';

import { MatDialogRef } from '@angular/material/dialog';

import { LoginService } from '../../login/login.service';
import { LoginSettings } from '../../login/LoginSetting.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
  selector: 'reportHeader',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.css']
})
export class ReportHeaderComponent implements OnInit, OnDestroy {

  loginSettings: LoginSettings;

  constructor(
    private dialogRef: MatDialogRef<ReportHeaderComponent>,
    private reportService: ReportingService,
    private loginService: LoginService
  ) {
    this.loginSettings = loginService.LoginSettings;

  } // end constructor


  ngOnInit() { }

  ngOnDestroy() { }

  // closeReportingWindow(){
  //     console.log("ReportHeaderComponent.ts=>closeReportingWindow()");
  // }

  closeClick() {
   // console.log('ReportHeaderComponent.ts => closeClick()');
    this.dialogRef.close();
  }

} // end export class ReportHeaderComponent




